import { Action, createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';

import { KycIdentification } from '@models/kyc-identification.model';

import * as KycIdentificationActions from './kyc-identification-actions';

export type KycIdentificationState = KycIdentification | null;
export const initialState: KycIdentificationState = null;

const kycIdentificationReducer = createReducer(
  initialState,
  on(KycIdentificationActions.select, setKycIdentification),
  on(KycIdentificationActions.update, setKycIdentification),
  on(KycIdentificationActions.loadSuccess, setKycIdentification),
  on(KycIdentificationActions.remove, () => initialState)
);

function setKycIdentification(
  _,
  { kycIdentification }: { kycIdentification: KycIdentification }
): KycIdentificationState {
  return cloneDeep(kycIdentification);
}

export function reducer(state: KycIdentificationState, action: Action): KycIdentificationState {
  return kycIdentificationReducer(state, action);
}
